<template>
  <HeaderPage/>
  <BodyPage/>
  <FooterPage/>
</template>
<script lang="ts" setup>
  import HeaderPage from './components/HeaderPage.vue';
  import BodyPage from './components/BodyPage.vue';
  import FooterPage from './components/FooterPage.vue';
  // import {navItems as items} from "@/utils/data"
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
  background-color: #F3F6F9;
  min-width: 1440px;
}
</style>
